import { useQueryClient } from "@tanstack/react-query";

export default function useInvalidateTeamMembers(shopId: string) {
	const queryClient = useQueryClient();
	return () => {
		queryClient.invalidateQueries({
			queryKey: [
				"get",
				"/shops/{shopId}/members",
				{ params: { path: { shopId } } },
			],
		});
	};
}
